import connector from 'Utils/connector';
import Login from 'Webapp/shared/app/views/login';

export default connector({
  selectors: {},
})(Login);
